const AlertIcon = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.3" width="34" height="34" rx="6" fill="#77D1F3" />
      <path
        d="M18.7735 8.71436L18.4619 20.1721H15.5376L15.218 8.71436H18.7735ZM16.9998 25.2857C16.4724 25.2857 16.0196 25.0993 15.6414 24.7264C15.2633 24.3482 15.0768 23.8955 15.0821 23.3681C15.0768 22.8461 15.2633 22.3987 15.6414 22.0258C16.0196 21.6529 16.4724 21.4665 16.9998 21.4665C17.5058 21.4665 17.9506 21.6529 18.3341 22.0258C18.7176 22.3987 18.912 22.8461 18.9174 23.3681C18.912 23.7197 18.8188 24.0419 18.6377 24.3349C18.4619 24.6226 18.2302 24.8543 17.9426 25.0301C17.6549 25.2005 17.3407 25.2857 16.9998 25.2857Z"
        fill="#00629B"
      />
    </svg>
  );
};

export default AlertIcon;
